import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-risk-mapping-score-column',
  templateUrl: './risk-mapping-score-column.component.html',
  styleUrls: ['./risk-mapping-score-column.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class RiskMappingScoreColumnComponent {
  @Input() public dictSeverity: Record<string, number> | undefined;

  constructor(
    private readonly _router: Router,
    private readonly _activatedRoute: ActivatedRoute
  ) {}

  public showColumn(severity: string): boolean {
    if (this.dictSeverity && severity in this.dictSeverity && this.dictSeverity[severity] > 0) {
      return true;
    } else {
      return false;
    }
  }
  public getSeverityCount(severity: string): number {
    return this.dictSeverity ? this.dictSeverity[severity] : 0;
  }
}
